import { Collapse } from "antd";
import {
  privacyPolicyItems,
  termsOfUseItems,
} from "../../../constants/terms-and-policy";
import "./styles.scss";
import HeaderBack from "../../../helbest/HeaderBack/HeaderBack";
import { Page } from "../../../helbest";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { ReactComponent as BottomArrowIcon } from "../../../assets/svg/bottom-arrow.svg";

export const TermsAndPolicyPage = () => {
  const { t, i18n } = useTranslation();

  const policyItems = useMemo(() => {
    return privacyPolicyItems.map((item, index) => ({
      style: {
        marginBottom: "24px",
        boxShadow: "1px 1px 13px 0px #0000000D",
        borderRadius: "12px",
      },
      styles: {
        header: {
          padding: "12px",
          fontSize: "16px",
          color: "#2B328B",
        },
        body: {
          marginInline: "12px",
          color: "#2B328B",
        },
      },
      key: item.key,
      label: `${index + 1}. ${
        i18n.language === "en" ? item.header : item.translated_header
      }`,
      children: i18n.language === "en" ? item.content : item.translated_content,
    }));
  }, []);

  const termsItems = useMemo(() => {
    return termsOfUseItems.map((item, index) => ({
      style: {
        marginBottom: "24px",
        boxShadow: "1px 1px 13px 0px #0000000D",
        borderRadius: "12px",
      },
      styles: {
        header: {
          padding: "12px",
          fontSize: "16px",
          color: "#2B328B",
        },
        body: {
          marginInline: "12px",
          color: "#2B328B",
        },
      },
      key: item.key,
      label: `${index + 1}. ${
        i18n.language === "en" ? item.header : item.translated_header
      }`,
      children: i18n.language === "en" ? item.content : item.translated_content,
    }));
  });

  return (
    <>
      <Page
        address="/"
        show
        showFooter
        customHeader={
          <HeaderBack url={"/login/"} title={t("drawer.terms_and_policy")} />
        }
        logo
        back
      >
        <div style={{ paddingBlock: "16px" }}>
          <div className="terms-and-policy-collapse">
            <h2>{t("terms_and_policy.privacy_policy")}</h2>
            <Collapse
              ghost
              style={{
                backgroundColor: "#fff",
                padding: "16px",
                paddingBottom: "8px",
              }}
              expandIconPosition="end"
              expandIcon={({ isActive }) => (
                <BottomArrowIcon
                  transform={`rotate(${isActive ? 180 : 0})`}
                  width="10px"
                />
              )}
              items={policyItems}
            />
          </div>
          <div className="terms-and-policy-collapse mt-4">
            <h2>{t("terms_and_policy.terms_use")}</h2>
            <Collapse
              ghost
              style={{
                backgroundColor: "#fff",
                padding: "16px",
                paddingBottom: "8px",
              }}
              expandIconPosition="end"
              expandIcon={({ isActive }) => (
                <BottomArrowIcon
                  transform={`rotate(${isActive ? 180 : 0})`}
                  width="10px"
                />
              )}
              items={termsItems}
            />
          </div>
        </div>
      </Page>
    </>
  );
};
